// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"ButtonWithName_tooltip__37lG1","wrapper":"ButtonWithName_wrapper__2hqtI"};